<template>
  <ds-dialog
    id="media-upload-preview"
    size="lg"
    :title="`Voorbeeld — ${mediaTypeLabel}`"
    @close="$emit('cancel')"
  >
    <div v-if="loading" class="media-upload-preview__loading">
      <ds-spinner inline /> Voorbeeld laden…
    </div>
    <iframe v-else :src="previewUrl" class="media-upload-preview__frame" title="PDF voorbeeld" />
    <template #footer>
      <ds-button variant="text" data-qa="media-upload-cancel-button" @click="$emit('cancel')">
        Annuleren
      </ds-button>
      <ds-button data-qa="media-upload-confirm-button" @click="$emit('confirm')">
        Uploaden
      </ds-button>
    </template>
  </ds-dialog>
</template>

<script>
import DsButton from '@/components/ds/atoms/dsButton/DsButton.vue'
import DsSpinner from '@/components/ds/atoms/dsSpinner/DsSpinner.vue'
import DsDialog from '@/components/ds/molecules/dsDialog/DsDialog.vue'

export default {
  name: 'MediaUploadPreviewModal',
  components: { DsButton, DsSpinner, DsDialog },
  props: {
    mediaTypeLabel: { type: String, required: true },
    previewUrl: { type: String, default: null },
    loading: { type: Boolean, default: false },
  },
  emits: ['confirm', 'cancel'],
}
</script>

<style lang="scss" scoped>
.media-upload-preview__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-2);
  padding: var(--ds-space-8) 0;
  color: var(--ds-color-text-muted);
}

.media-upload-preview__frame {
  width: 100%;
  height: 62vh;
  border: 0;
  border-radius: var(--ds-radius-md);
  background: var(--ds-color-surface-sunken);
}
</style>
